import { createFileRoute } from '@tanstack/react-router'
import RegistrationClosedPage from '@/components/pages/RegistrationClosedPage/RegistrationClosedPage'

export const Route = createFileRoute('/registration-closed')({
  component: RegistrationClosedRoute,
})

function RegistrationClosedRoute() {
  return <RegistrationClosedPage />
}
